





























import { Component, Vue } from 'vue-property-decorator'
import { downloadState } from '../../store/modules/DownloadState'
import { Conditions } from '../../modules/class/PdfDownload/Conditions'
import { DownloadLinkInfo } from '../../modules/class/Downloads'
import PdfList from '../../components/PdfLink/PdfList.vue'
import PdfTable from '../../components/PdfLink/PdfTable.vue'

@Component({
  components: { PdfList, PdfTable }
})
export default class PdfDownloadTable extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data

  // 抽出条件（main.tsから連携される）
  private conditions: Conditions = new Conditions()
  private pdfList: DownloadLinkInfo[] = []

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * コンポーネントから渡された一覧を更新
   */
  private updatePdfList(data: DownloadLinkInfo[]) {
    this.pdfList = data

    // アンカーリンクを追加
    if (this.pdfList.length > 0) {
      downloadState.setAnchor(this.conditions.anchor)
    }
  }
}
